module.exports = "https://static.energy5.com/_next/static/images/cert2-338e7315966f159c003be93e48b72588.png";